"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ColumnWebhookManager () {
        return ColumnWebhookManager;
    },
    get ColumnWebhookManagerBuilder () {
        return ColumnWebhookManagerBuilder;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ColumnWebhookManagerBuilder = class ColumnWebhookManagerBuilder {
    withModelManager(modelWebhookManager) {
        this.modelWebhookManager = modelWebhookManager;
        return this;
    }
    withModel(model) {
        this.modelId = model.id;
        return this;
    }
    async withModelId(modelId) {
        this.modelId = modelId;
        return this;
    }
    addColumn(column) {
        if (this.oldColumns.find((col)=>col.id === column.id)) {
            return this;
        }
        if (column.system) {
            return this;
        }
        this.oldColumns.push(column);
        return this;
    }
    async addColumnById(columnId) {
        if (this.oldColumns.find((col)=>col.id === columnId)) {
            return this;
        }
        // needed to prevent circular dependencies
        const columnsV3Service = _Noco.default.nestApp.get('IColumnsV3Service');
        const column = await columnsV3Service.columnGet(this.context, {
            columnId
        }, this.ncMeta);
        if (column.system) {
            return this;
        }
        this.oldColumns.push(column);
        return this;
    }
    forCreate() {
        return new ColumnWebhookManager(this.context, {
            action: _nocodbsdk.WebhookActions.INSERT,
            modelId: this.modelId,
            modelWebhookManager: this.modelWebhookManager,
            oldColumns: this.oldColumns
        });
    }
    forUpdate() {
        return new ColumnWebhookManager(this.context, {
            action: _nocodbsdk.WebhookActions.UPDATE,
            modelId: this.modelId,
            oldColumns: this.oldColumns,
            modelWebhookManager: this.modelWebhookManager
        });
    }
    forDelete() {
        return new ColumnWebhookManager(this.context, {
            action: _nocodbsdk.WebhookActions.DELETE,
            modelId: this.modelId,
            oldColumns: this.oldColumns,
            modelWebhookManager: this.modelWebhookManager
        }, this.ncMeta);
    }
    constructor(context, ncMeta){
        this.context = context;
        this.ncMeta = ncMeta;
        this.oldColumns = [];
    }
};
let ColumnWebhookManager = class ColumnWebhookManager {
    async populateNewColumns() {
        return this;
    }
    async addOldColumnById(_param) {
        return this;
    }
    async addOldColumn(_param) {
        return this;
    }
    async addNewColumnById(_param) {
        return this;
    }
    async addNewColumn(_param) {
        return this;
    }
    emit() {}
    constructor(context, params, ncMeta){
        var _this_params_newColumns;
        this.context = context;
        this.params = params;
        this.ncMeta = ncMeta;
        this.emitted = false;
        this.params.newColumns = (_this_params_newColumns = this.params.newColumns) != null ? _this_params_newColumns : [];
    }
};
